import React from "react";

export default function Web_CLI() {
  return (
    <div>
      <h1>What is CLI</h1>
      <p>
        Route: <code>/web/cli</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
